/* eslint-disable import/no-anonymous-default-export */
export default {
  translation: {
    global: {
      title: 'Wo Technik auf Exzellenz trifft',
      subtitle:
        'Wir entwickeln Software, die Unternehmen voranbringt. Von der Strategie bis zum Launch bringen wir Praezision, Kreativitaet und tiefes technisches Know-how in jedes Projekt.',
      button: 'Kostenloses Beratungsgespraech buchen',
    },
    about: {
      title: 'Ueber Uns',
      subtitle:
        'Ein Team aus Ingenieuren, Designern und Strategen, die daran glauben, dass grossartige Software damit beginnt, Ihr Unternehmen in- und auswendig zu verstehen.',
    },
    services: {
      title: 'Dienstleistungen',
      subtitle:
        'Vom ersten Prototyp bis zum fertigen Produkt: Wir bauen digitale Loesungen, die Bestand haben.',
    },
    contact: {
      title: 'Kontakt',
      subtitle:
        'Erzaehlen Sie uns, woran Sie arbeiten. Wir freuen uns, von Ihrem Projekt zu hoeren und zu sehen, wie wir helfen koennen.',
    },
    faqs: {
      title: 'Haeufige Fragen',
      subtitle:
        'Sie moechten wissen, wie wir arbeiten? Hier finden Sie Antworten auf die Fragen, die unsere Kunden am haeufigsten stellen. Wenn Ihre Frage nicht dabei ist, schreiben Sie uns einfach.',
      question1: 'Wie lange dauert es typischerweise, eine massgeschneiderte Software zu entwickeln?',
      answer1:
        'Jedes Projekt ist anders. Ein fokussiertes MVP kann acht bis zwoelf Wochen dauern, waehrend eine komplexere Plattform mehrere Monate in Anspruch nehmen kann. In unserem ersten Gespraech erfassen wir Ihre Anforderungen und geben Ihnen eine realistische Zeitplanung.',
      question2:
        'Bieten Sie auch nach dem Launch Unterstuetzung an?',
      answer2:
        'Auf jeden Fall. Der Launch ist erst der Anfang. Wir bieten laufende Wartung, Sicherheitsupdates und Funktionserweiterungen, die auf Ihre Beduerfnisse zugeschnitten sind. Betrachten Sie uns als Ihren langfristigen Technologiepartner.',
      question3:
        'Wie gehen Sie mit Datensicherheit und Vertraulichkeit um?',
      answer3:
        'Das nehmen wir sehr ernst. Unser Team folgt branchenueblichen Best Practices fuer Verschluesselung, Zugriffskontrolle und sichere Programmierung. Wir unterzeichnen gerne NDAs und besprechen spezifische Compliance-Anforderungen in unserem ersten Gespraech.',
      question4:
        'Koennen Sie sich in unsere bestehenden Systeme integrieren?',
      answer4:
        'Ja. Wir haben umfangreiche Erfahrung mit CRMs, Payment-Gateways, ERP-Systemen und Drittanbieter-APIs. Nahtlose Integration ist immer Teil des Plans.',
      question5:
        'Wie stellen Sie sicher, dass das Endprodukt benutzerfreundlich ist?',
      answer5:
        'Wir designen fuer echte Menschen. Das bedeutet User Research, Wireframes und iteratives Testing, bevor eine einzige Zeile Produktivcode geschrieben wird. Ihr Feedback ist uns dabei jederzeit willkommen.',
      question6: 'Wie sieht Ihr Projektmanagement-Prozess aus?',
      answer6:
        'Wir arbeiten in agilen Sprints mit regelmaessigen Check-ins, damit Sie immer wissen, wo die Dinge stehen. Sie haben einen festen Ansprechpartner, Zugang zu unserem Projektboard und Demos am Ende jedes Sprints.',
      question7: 'Wie strukturieren Sie Ihre Preise?',
      answer7:
        'Wir kalkulieren basierend auf Umfang und Komplexitaet. Nach unserem Discovery-Gespraech erhalten Sie ein detailliertes Angebot mit klaren Leistungen und Kosten. Keine versteckten Gebuehren.',
    },
    footer: {
      title:
        'Wir verwandeln mutige Ideen in durchdachte digitale Produkte, die unseren Kunden beim Wachstum helfen. Vom Konzept ueber den Launch bis darueber hinaus ist Hizelus Ihr Partner.',
      userfulLinks: {
        title: 'Schnelllinks',
        home: 'Startseite',
        about: 'Ueber Uns',
        services: 'Dienstleistungen',
        contact: 'Kontakt',
        faqs: 'FAQs',
      },
      contact: {
        title: 'Kontakt',
        address: 'Wandsbeker Chaussee 212, 22089 Hamburg',
        phone: '+4917642056661',
        email: 'contact@hizelus.com',
      },
      social: {
        title: 'Social Media',
        facebook: 'Facebook',
        twitter: 'Twitter',
        instagram: 'Instagram',
        linkedin: 'LinkedIn',
      },
    },
    header: {
      home: 'Startseite',
      about: 'Ueber Uns',
      services: 'Dienstleistungen',
      contact: 'Kontakt',
      faqs: 'FAQs',
      jobs: 'Trainings',
    },
    coreServices: {
      title: 'Was wir am besten koennen',
      subtitle:
        'Wir vereinen tiefes technisches Wissen mit einem scharfen Auge fuer Design. Von KI-gesteuerten Produkten bis hin zu lueckenloser Sicherheit deckt unser Team das gesamte Spektrum ab.',
      service1: {
        title: 'Design',
        description:
          'Grossartige Produkte beginnen mit durchdachtem Design. Wir gestalten Oberflaechen, die beeindrucken und sich muehelos anfuehlen, von User Flows ueber Wireframes bis hin zu pixelgenauen Screens.',
      },
      service2: {
        title: 'Mobile Entwicklung',
        description:
          'Wir bauen native und plattformuebergreifende Apps, die Menschen gerne nutzen. Schnelle Performance, saubere Architektur und nahtlose Erlebnisse auf iOS und Android.',
      },
      service3: {
        title: 'Web Entwicklung',
        description:
          'Ob Marketingseite oder komplexe Webanwendung: Wir liefern schnelle, barrierefreie und responsive Loesungen mit modernen Frameworks und bewaehrten Best Practices.',
      },
      service4: {
        title: 'Branding',
        description:
          'Ihre Marke ist mehr als ein Logo. Wir arbeiten mit Ihnen an Ihrer visuellen Identitaet, Tonalitaet und Designsprache, damit jeder Beruehrungspunkt stimmig und einpraegsam ist.',
      },
      service5: {
        title: 'Data Engineering',
        description:
          'Gute Entscheidungen beginnen mit guten Daten. Wir entwerfen Pipelines, bauen Data Warehouses und richten Dashboards ein, die aus Rohdaten verwertbare Erkenntnisse machen.',
      },
      service6: {
        title: 'Kuenstliche Intelligenz',
        description:
          'Wir helfen Unternehmen, KI zu nutzen, um Arbeitsablaeufe zu automatisieren, verborgene Muster aufzudecken und intelligente Produkte zu bauen. Von Machine-Learning-Modellen bis hin zu Chatbots verwandeln wir Daten in Wettbewerbsvorteile.',
      },
      service7: {
        title: 'Cyber-Sicherheit',
        description:
          'Ihre digitalen Werte verdienen ernsthaften Schutz. Wir fuehren Sicherheitsaudits durch, bauen sichere Architekturen und implementieren Bedrohungserkennungssysteme, die Ihr Unternehmen rund um die Uhr schuetzen.',
      },
      more_services: {
        text: 'Alle Dienstleistungen entdecken',
      },
    },
    feedBack: {
      title: 'Was unsere Kunden sagen',
      step1: {
        name: 'Philipp Schneiderwind',
        position: 'CEO, Unternehmen',
        feedback:
          '"Hizelus hat unsere Webpraesenz komplett transformiert. Das Team hat unsere Vision vom ersten Tag an verstanden und eine Seite geliefert, die nicht nur hervorragend aussieht, sondern echte Ergebnisse bringt."',
      },
      step2: {
        name: 'Ogbonna Chinedu Emmanuel',
        position: 'CEO, Unternehmen',
        feedback:
          '"Unsere Mobile App ging in Rekordzeit vom Konzept in den App Store und die Qualitaet spricht fuer sich. Hizelus hat sich die Zeit genommen, unsere Nutzer wirklich zu verstehen. Das Ergebnis ist eine App, die unsere Kunden lieben."',
      },
      step3: {
        name: 'Emma Duru',
        position: 'CEO, Unternehmen',
        feedback:
          '"Hizelus fuer unser Beratungsprojekt zu waehlen, war eine der besten Entscheidungen, die wir getroffen haben. Das Team brachte Klarheit in eine komplexe Situation und half uns, Wachstumschancen zu identifizieren, die wir voellig uebersehen hatten."',
      },
    },
    ourWork: {
      title: 'Unsere Arbeit',
      subtitle:
        'Wir messen unseren Erfolg an der Wirkung, die wir fuer unsere Kunden erzielen. Jedes Projekt steht fuer eine echte geschaeftliche Herausforderung, die mit durchdachtem Engineering und Design geloest wurde.',
      work1: {
        title: 'Projekt 1',
        subtitle: 'Ein digitales Produkt, das die Nutzerinteraktion neu definiert hat.',
      },
      work2: {
        title: 'Projekt 2',
        subtitle: 'Eine End-to-End-Loesung fuer Skalierbarkeit und Zuverlaessigkeit.',
      },
      work3: {
        title: 'Projekt 3',
        subtitle: 'Eine mutige Markenvision, umgesetzt durch Code und Kreativitaet.',
      },
      work4: {
        title: 'Projekt 4',
        subtitle: 'Ein mobiles Erlebnis, das um die Beduerfnisse echter Nutzer gestaltet wurde.',
      },
      work5: {
        title: 'Projekt 5',
        subtitle: 'Datengetriebene Erkenntnisse, die Entscheidungsprozesse transformierten.',
      },
      work6: {
        title: 'Projekt 6',
        subtitle: 'Eine vollstaendige digitale Neugestaltung fuer ein wachsendes Unternehmen.',
      },
    },
    booking: {
      title: 'Etwas Bemerkenswertes bauen',
      subtitle:
        'Bereit, Ihre naechste Idee zum Leben zu erwecken? Buchen Sie ein kostenloses Beratungsgespraech und lassen Sie uns zeigen, was moeglich ist. Wir hoeren zu, stellen die richtigen Fragen und erstellen einen Plan, der zu Ihren Zielen und Ihrem Budget passt.',
      button: 'Kostenloses Beratungsgespraech buchen',
    },
    coreValue: {
      title: 'Unsere Grundwerte',
      subtitle:
        'Alles, was wir bauen, wird von Prinzipien geleitet, die wir ernst nehmen. Integritaet, Innovation und Exzellenz sind keine leeren Worte. Sie praegen, wie wir arbeiten, kommunizieren und liefern.',
      value1: {
        title: 'Integritaet',
        subtitle:
          'Wir sagen, was wir meinen, und liefern, was wir versprechen. Ehrliche Kommunikation und Transparenz sind das Fundament jeder Kundenbeziehung.',
      },
      value2: {
        title: 'Innovation',
        subtitle:
          'Technologie entwickelt sich schnell und wir auch. Wir bleiben neugierig, nutzen neue Werkzeuge und Ansaetze und bringen frisches Denken in jede Herausforderung.',
      },
      value3: {
        title: 'Teamarbeit',
        subtitle:
          'Grossartige Arbeit entsteht, wenn talentierte Menschen offen zusammenarbeiten. Wir bringen diverse Perspektiven und Faehigkeiten zusammen.',
      },
      value4: {
        title: 'Exzellenz',
        subtitle:
          'Gut genug ist nie genug. Wir halten uns an die hoechsten Standards in Codequalitaet, Design und Kundenkommunikation.',
      },
      value5: {
        title: 'Kundenfokus',
        subtitle:
          'Ihr Erfolg ist unser Erfolg. Wir hoeren aufmerksam zu, passen uns schnell an und stellen sicher, dass jede Entscheidung Ihren Geschaeftszielen dient.',
      },
    },
    whoWeAre: {
      title: 'Wer wir sind',
      subtitle:
        'Hizelus Engineering ist eine Software-Beratung aus Hamburg, gegruendet von Ingenieuren, die Wert auf Handwerkskunst legen. Wir arbeiten mit Startups und etablierten Unternehmen gleichermassen zusammen, um digitale Produkte zu entwerfen, zu bauen und zu skalieren, die einen echten Unterschied machen.',
    },
    whyWeDoIt: {
      title: 'Warum wir das tun',
      subtitle:
        'Wir haben Hizelus gegruendet, weil wir glauben, dass jedes Unternehmen Zugang zu erstklassiger Software verdient. Zu viele Unternehmen geben sich mit mittelmassiger Technologie zufrieden. Wir sind hier, um das zu aendern.',
    },
    team: {
      title: 'Das Team hinter Hizelus',
      subtitle:
        'Unsere Staerke liegt in den Menschen, die jeden Tag mit Leidenschaft, Koennen und dem aufrichtigen Wunsch auftreten, etwas Grossartiges zu schaffen.',
      member1: {
        name: 'Hilary Ogalagu',
        position: 'CEO, Software Engineer',
      },
      member2: {
        name: 'Narender Vaddepelly',
        position: 'CTO, Senior Software Developer',
      },
      member3: {
        name: 'Kenneth Obi',
        position: 'FullStack Developer',
      },
      member4: {
        name: 'Vanessa Laturnus',
        position: 'Content Manager',
      },
      member5: {
        name: 'John Doe',
        position: 'CEO, Unternehmen',
      },
      member6: {
        name: 'John Doe',
        position: 'CEO, Unternehmen',
      },
    },
    stayConnected: {
      title: 'Bleiben Sie verbunden',
      subtitle:
        'Treten Sie unserer Community bei und erhalten Sie Einblicke in Technologietrends, Produktentwicklung und was wir als Naechstes bauen. Kein Spam, nur das Gute.',
      button: 'Abonnieren',
    },
    OurServices: {
      title: 'UNSERE DIENSTLEISTUNGEN',
      title1: 'Design',
      subtitle1:
        'Wir glauben, dass schoenes Design echte Ergebnisse erzielt. Unsere Designer arbeiten eng mit Ihnen zusammen, um Oberflaechen und Erlebnisse zu gestalten, die Ihre Marke einfangen und Ihre Nutzer begeistern.',
      title2: 'Mobile Entwicklung',
      subtitle2:
        'Smartphones sind dort, wo Ihre Kunden leben. Wir bauen schnelle, zuverlaessige und elegante Mobile Apps fuer iOS und Android, die Menschen immer wieder zurueckkommen lassen.',
      title3: 'Web Entwicklung',
      subtitle3:
        'Ihre Website ist oft der erste Eindruck. Wir kombinieren sauberen Code mit schonem Design, um responsive, leistungsstarke Web-Erlebnisse zu schaffen, die Besucher zu Kunden machen.',
      title4: 'Branding',
      subtitle4:
        'Eine starke Marke baut auf Konsistenz und Klarheit. Vom Logo-Design bis zum Messaging-Framework helfen wir Ihnen, eine visuelle Identitaet zu definieren, die bei Ihrer Zielgruppe ankommt.',
      title5: 'Digitales Marketing',
      subtitle5:
        'Wir helfen Ihnen, die richtigen Menschen zur richtigen Zeit zu erreichen. Durch strategische digitale Kampagnen, Content-Planung und Analytik verwandeln wir Ihre Online-Praesenz in einen Wachstumsmotor.',
      title6: 'Beratung',
      subtitle6:
        'Sie wissen nicht, wo Sie anfangen sollen? Unsere Berater bringen jahrzehntelange Erfahrung mit, um Ihnen bei klugen Technologieentscheidungen zu helfen und kostspielige Fehler zu vermeiden.',
      title7: 'Datenmanagement',
      subtitle7:
        'Ihre Daten sind einer Ihrer wertvollsten Vermoegenswerte. Wir bauen die Infrastruktur, um sie zu sammeln, zu speichern, zu analysieren und darauf zu reagieren.',
      title8: 'Kuenstliche Intelligenz',
      subtitle8:
        'Wir bauen KI-Loesungen, die echte Probleme loesen. Ob praediktive Modelle, natuerliche Sprachverarbeitung, Computer Vision oder intelligente Automatisierung — wir entwerfen und implementieren KI-Systeme, die sich nahtlos in Ihr Unternehmen integrieren.',
      title9: 'Cyber-Sicherheit',
      subtitle9:
        'In einer Welt, in der sich Bedrohungen taeglich weiterentwickeln, muss Ihre Sicherheit voraus sein. Wir bieten umfassende Sicherheitsbewertungen, Penetrationstests, sichere Architektur und Echtzeitueberwachung zum Schutz Ihrer digitalen Infrastruktur.',
    },
    HowWeDoIt: {
      title: 'Wie wir Ihre Vision verwirklichen',
      subtitle:
        'Ein bewaehrter Prozess, verfeinert ueber Jahre erfolgreicher Projektarbeit.',
      step1: {
        title: 'Vision definieren',
        subtitle:
          'Wir setzen uns mit Ihnen zusammen, um Ihre Ziele, Ihre Zielgruppe und Ihren Markt zu verstehen. Gemeinsam formen wir ein klares Produktkonzept.',
      },
      step2: {
        title: 'Idee validieren',
        subtitle:
          'Bevor wir bauen, testen wir. Durch Research, Prototyping und Nutzerfeedback stellen wir sicher, dass Ihre Idee starken Markt-Fit hat.',
      },
      step3: {
        title: 'Produkt bauen',
        subtitle:
          'Unsere Ingenieure und Designer arbeiten in agilen Sprints. Sie sehen jede Woche Fortschritte, und Ihr Feedback formt jede Iteration.',
      },
      step4: {
        title: 'Mit Zuversicht launchen',
        subtitle:
          'Wir helfen Ihnen, einen Launch zu planen, der maximale Wirkung erzielt. Von der Bereitstellung bis zur Marketingunterstuetzung.',
      },
      step5: {
        title: 'Risiken minimieren',
        subtitle:
          'Risikomanagement ist in alles eingebaut, was wir tun. Wir identifizieren potenzielle Probleme frueh und testen gruendlich.',
      },
    },
    contactForm: {
      title: 'Kontakt',
      title1: 'IHRE DATEN',
      subtitle:
        'Ich moechte Updates und Insights von Hizelus Engineering erhalten',
      button: 'Absenden',
    },
    contactUs: {
      title: 'Kontakt',
      subtitle:
        'Ob Sie ein konkretes Projekt im Kopf haben oder einfach erkunden moechten, was moeglich ist, wir sind fuer Sie da. Wir antworten in der Regel innerhalb eines Werktages.',
      address: 'Adresse',
      address1: 'Wandsbeker Chaussee 212, 22089 Hamburg, Deutschland',
      phone: 'Telefon',
      phone1: '+4917642056661',
      email: 'E-Mail',
      email1: 'hilary@hizelus.com',
      title1: 'Lassen Sie uns gemeinsam etwas bauen',
      subtitle1:
        'Wir wuerden gerne mehr ueber Ihr Projekt erfahren. Erzaehlen Sie uns, woran Sie arbeiten, und wir erstellen einen Plan, der zu Ihrem Zeitrahmen und Budget passt.',
      button: 'Absenden',
      title3: 'Sie koennen uns auch direkt erreichen',
    },
    whatsNext: {
      title: 'Wie geht es weiter?',
      step1: {
        title: 'Erstes Gespraech',
        subtitle:
          'Wir starten mit einem entspannten Gespraech ueber Ihr Projekt, Ihre Ziele und Ihren Zeitplan. Keine Verpflichtungen, nur ein echtes Gespraech.',
      },
      step2: {
        title: 'Detailliertes Angebot',
        subtitle:
          'Basierend auf unserem Gespraech erstellen wir ein klares Angebot mit Umfang, Zeitplan und Investition. Sie wissen genau, was Sie erwartet.',
      },
      step3: {
        title: 'Tiefgehende Analyse',
        subtitle:
          'Sobald wir uns einig sind, fuehren wir gruendliche Anforderungssessions durch. Hier gehen wir in die Details, die den Unterschied zwischen gut und grossartig ausmachen.',
      },
      step4: {
        title: 'Design & Architektur',
        subtitle:
          'Unsere Designer und Architekten erstellen den Bauplan fuer Ihre Loesung. Wireframes, Prototypen und technische Plaene kommen in dieser Phase zusammen.',
      },
      step5: {
        title: 'Entwicklung & Testing',
        subtitle:
          'Wir bauen in fokussierten Sprints mit kontinuierlichem Testing. Sie erhalten regelmaessige Demos und die Moeglichkeit, in jeder Phase Feedback zu geben.',
      },
      step6: {
        title: 'Enge Zusammenarbeit',
        subtitle:
          'Ihr Input zaehlt in jedem Schritt. Wir teilen Fortschritte offen, freuen uns ueber ehrliches Feedback und passen den Kurs bei Bedarf an.',
      },
      step7: {
        title: 'Auslieferung & Support',
        subtitle:
          'Wenn Ihr Produkt fertig ist, uebernehmen wir das Deployment, liefern umfassende Dokumentation und bleiben fuer laufenden Support und zukuenftige Erweiterungen verfuegbar.',
      },
    },
    aboutUsStatus: {
      customer: 'Zufriedene Kunden',
      team: 'Teammitglieder',
      products: 'Produkte gelauncht',
      community: 'Community-Mitglieder',
    },
  },
}
